// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__1cLF6"};